import axios from "@/composables/Axios";
import dayjs from "dayjs";

const meterToKilo = (meter) => {
    if (typeof meter !== 'number') {
        return 0;
    }

    return meter / 1000;
}
const secToMinute = (sec) => {
    const h = parseInt(sec / 3600);
    const m = parseInt((sec - (h * 3600)) / 60);
    const s = sec % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

const getHourFromSec = (sec) => {
    let hm = secToHourMinute(sec);
    return `${hm.split(":")[0]}시간${hm.split(":")[1]}분`;
}

const secToHourMinute = (sec) => {
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec % 3600) / 60);
    let secs = sec % 60;
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

const secToHourMinuteExcel = (sec) => {
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec % 3600) / 60);
    return `${hours}:${minutes.toString().padStart(2, '0')}`;
}

const secToDayPercent = (sec) => {
    const dayInSec = 86400;
    return (sec / dayInSec);
}

const timezoneOffset = new Date().getTimezoneOffset() * 60000;

const startDateInit = (n) => {
    return startDateInitWithHour(n, "00");
}

const startMonthInit = () => {
    const nowMonth = dayjs().startOf('month');
    return nowMonth.format('YYYY-MM');
}

const isAdminMode = () => {
    return window.location.hash === '#admin';
}

const getMinSearchMonth = () => {
    if (isAdminMode()) {
        return `1970-01`;
    }

    return `2000-01`;
}

const getMaxSearchMonth = () => {
    return dayjs().format('YYYY-MM');
}

const getMinSearchDate = (longFormat = false) => {
    const suffix = longFormat ? 'T00:00:00' : '';
    if (isAdminMode()) {
        return `1970-01-01${suffix}`;
    }

    return `2000-01-01${suffix}`;
}

const getMaxSearchDate = (longFormat = false) => {
    return dayjs().format(longFormat ? 'YYYY-MM-DDTHH:mm:ss' : 'YYYY-MM-DD');
}

const startDateInitWithHour = (n, hour) => {
    let targetDate = dayjs(dayjs().format("YYYY-MM-DDT00:00:00")).subtract(n, 'day');
    return targetDate.format(`YYYY-MM-DDT${hour}:00:00`);
}

const changeFormat = (date, format) => {
    const dateJS = dayjs(date);
    if (!dateJS.isValid()) {
        return '-';
    }
    return dayjs(date).format(format);
}

const endDateInit = () => {
    let endDate = dayjs();
    return endDate.format('YYYY-MM-DDT00:00:00')
}

const endMaxDateInit = () => {
    let endDate = dayjs();
    return endDate.format("YYYY-MM-DDTHH:mm:ss");
}

// date => date.0초
const startDateSetSecond = (date, hour) => {
    if (!hour) hour = "00";
    if (!date) return;
    return dayjs(date).format(`YYYYMMDD${hour}mm00`);
}

// date -1초
const endDateSetSecond = (date, hour) => {
    if (!hour) hour = "00";
    if (!date) return;
    date = dayjs(date).format(`YYYYMMDD${hour}mm00`);
    return dayjs(date).subtract(1, 'second').format(`YYYYMMDDHHmmss`);
}

// date +1일
const datePlus1day = (date) => {
    if (!date) return;
    return dayjs(date).add(1, 'day').format('YYYY-MM-DD HH:mm:ss');
}

const datePlus1DayFormat = (date, format) => {
    if (!date) return;
    return dayjs(date).add(1, 'day').format(format);
}

// data + n일
const datePlusNday = (date, n) => {
    if (!date) return;
    return dayjs(date).add(n, 'day').format('YYYY-MM-DD HH:00:00');
}

const dateMinus1day = (date) => {
    if (!date) return;
    return dayjs(date).subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss');
}

const dateMinus1DayFormat = (date, format) => {
    if (!date) return;
    return dayjs(date).subtract(1, 'day').format(format);
}

// date - n일
const dateMinusNday = (date, n) => {
    if (!date) return;
    return dayjs(date).subtract(n, 'day').format('YYYY-MM-DD 00:00:00');
}

// date - n 초
const dateMinusNsecond = (date, n) => {
    if (!date) return;
    return dayjs(date).subtract(n, 'second').format('YYYY-MM-DD HH:mm:ss');
}

// date + 1일 -1초
const getEndSecond = (date) => {
    if (!date) return;
    return dayjs(date).add(1, 'day').subtract(1, 'second').format('YYYYMMDDHHmmss');
}
// date + 00:00:00
const getStartSecond = (date) => {
    if (!date) return;
    return dayjs(date).format('YYYYMMDD000000');
}

// yyyy-MM-dd => yyyy-MM-01
const setFirstDay = (date) => {
    if (!date) return;
    return dayjs(date).format('YYYY-MM-01')
}

// date => "yyyy-MM-dd"
const convertDate = (date) => {
    if (!date) return;
    return dayjs(date).format('YYYY-MM-DD');
}

const getDatesStartToEnd = (startDate, endDate) => {
    let result = [];
    let curDate = dayjs(convertDate(startDate)).add(9, 'hour').$d;
    while (curDate < dayjs(convertDate(endDate)).add(9, 'hour').$d) {
        result.push(curDate.toISOString().split("T")[0]);
        curDate.setDate(curDate.getDate() + 1);
    }
    return result;
}

const getDaysStartToEnd = (startDay, endDay) => {
    let result = [];
    let curDate = dayjs(startDay);
    while (curDate < dayjs(endDay)) {
        result.push(convertDate(curDate));
        curDate = curDate.add(1, 'day');
    }
    return result;
}

const removeEmpty = (value) => {
    if (value === undefined) return "";
    value = value.replace(/\s/g, "")
    if (value.length === 0) return "";
    return value;
}

const setSearchParams = (param, hour) => {
    return {
        startDate: dateFormatFuncForExcel(param.startDate, 'YYYYMMDDHHmmss'),
        endDate: dateFormatFuncForExcel(param.endDate, 'YYYYMMDDHHmmss'),
        officeId: param.officeId,
        carNum: param.carNum,
        driverId: param.driverId,
        payType: param.payType,
        periodType: param.periodType,
        queryDate: setFirstDay(param.queryDate),
        excelType: param.excelType,
        viewYn: param.viewYn,
        workDate: param.workDate
    }
}

// date => "HH:MM"
const convertDateToTime = (date) => {
    if (!date) return;
    return dayjs(date).format('mm:ss');
}

const dateFormatFunc = (date) => {
    if (!date) return;
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}

const dateFormatFuncForExcel = (date, format) => {
    if (!date) return;
    return dayjs(date).format(format);
}

// sec => "mm:ss"
const secToMinuteSecond = (sec) => {
    const m = parseInt(sec / 60);
    const s = sec % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

const insertComma = (amount) => {
    return Number(amount).toLocaleString('ko-KR');
}

const dateFormatForSearch = (queryParam) => {
    if (queryParam.startDate) {
        queryParam.startDate = startDateSetSecond(queryParam.startDate)
    }
    if (queryParam.endDate) {
        queryParam.endDate = endDateSetSecond(queryParam.endDate)
    }
    return queryParam
}

const carNumRegex = "[가-힣]{2,3}[0-9]{2}[가-힣]{1}[0-9]{4}";

const viewYN = (viewYn) => {
    return viewYn === 'Y' ? "" : 'Y';
}

const deleteYN = (deleteYn) => {
    return deleteYn === 'Y' ? true : false;
}

const getKeyByValue = (obj, value) => {
    const keyIndex = Object.values(obj).indexOf(value);
    return Object.keys(obj)[keyIndex];
}

const getRegions = async (url, headers) => {
    const rl = await axios.$get(url + 'region', {}, headers);
    const rm = {};
    rl.data.data.forEach(element => {
        rm[element.regionCode] = element.regionName;
    });

    return rm;
}

const validateCarNum = (carNum) => {
    let regex = /^[가-힣]{2}[0-9]{2}[가-힣][0-9]{4}$/
    return regex.test(carNum)
}

const validateEmployeeNum = (employeeNum) => {
    if (employeeNum === 'AAAA') {
        return true;
    }

    let regex = /^[0-9]{4}$/
    return regex.test(employeeNum)
}

const validateDriverId = (driverId) => {
    let regex = /^[0-9*]{9}$/
    return regex.test(driverId)
}

const validateOfficeId = (officeId) => {
    let regex = /^[0-9]{10}$/
    return regex.test(officeId)
}

const validatePhone = (number) => {
    let regex = /^[0-9]{8,11}$/
    return regex.test(number)
}

const validateTel = (number) => {
    let regex = /^[0-9]{8,12}$/
    return regex.test(number)
}

const validateFax = (number) => {
    let regex = /^[0-9]{8,12}$/
    return regex.test(number)
}

const makeKeys = (keyStr, item) => {
    let key = "";

    switch(keyStr) {
        case "DrivingAggregateDetails" :
            key = item.carNum + "-" + item.driverId + "-" + item.minDtti;
            break;
        case "DrivingAggregateCommuteDetails" :
            key = item.carNum + "-" + item.driverId + "-" + changeFormat(item.stDtti, 'YYYYMMDDHHmmss');
            break;
    }

    return key;
}

const makeDataTableFields = (fields)=>{
    let columnList = [];
    for( let i = 0 ; i < fields.length ; i++ ) {
        columnList.push( {"data":fields[i].key, "title":fields[i].label } );
    }
    return columnList;
};

const changeForJibulColumn = (orderData) => {
    let result = "";

    switch(orderData.column) {
        case "payFare":
            result = "allPayFare";
            break;

        case "hipassFare":
            result = "allHipassFare";
            break;

        case "addFare":
            result = "allAddFare";
            break;

        case "fare":
            result = "allFare";
            break;

        case "workDist":
            result = "allWorkDist";
            break;

        case "blankDist":
            result = "allEmptyDist";
            break;

        case "allDIst":
            result = "allBlankDist";
            break;

        case "workTime":
            result = "allWorkTime";
            break;

        case "blankTime":
            result = "allBlankTime";
            break;

        case "allTime":
            result = "allTime";
            break;

        default:
            result = orderData.column;
    }
    return result;
}

export {
    validateCarNum,
    validateEmployeeNum,
    validateDriverId,
    validateOfficeId,
    validatePhone,
    validateTel,
    validateFax,
    meterToKilo,
    secToMinute,
    startDateInit,
    startMonthInit,
    endDateInit,
    endMaxDateInit,
    startDateSetSecond,
    endDateSetSecond,
    removeEmpty,
    convertDate,
    getDatesStartToEnd,
    getDaysStartToEnd,
    datePlus1day,
    datePlus1DayFormat,
    dateMinus1DayFormat,
    datePlusNday,
    dateMinus1day,
    dateMinusNday,
    getEndSecond,
    getStartSecond,
    setSearchParams,
    carNumRegex,
    convertDateToTime,
    secToMinuteSecond,
    insertComma,
    dateFormatFunc,
    dateFormatForSearch,
    dateFormatFuncForExcel,
    secToHourMinute,
    secToHourMinuteExcel,
    viewYN,
    deleteYN,
    startDateInitWithHour,
    getKeyByValue,
    getHourFromSec,
    getRegions,
    changeFormat,
    dateMinusNsecond,
    makeKeys,
    makeDataTableFields,
    changeForJibulColumn,
    secToDayPercent,
    getMinSearchDate,
    getMaxSearchDate,
    isAdminMode,
    getMinSearchMonth,
    getMaxSearchMonth
};

